import { List } from './list-model';
import { Stats } from './stats';

export type IndexValueType = 'string' | 'number' | 'date';

export type IndexDefaultOrderDirection = 'asc' | 'desc';

// An index can only be queried once its values have been built, which happens
// in the background after it's created or its pointer changes
export type IndexBuildStatus = 'ready' | 'building' | 'failed';

export type Index = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  list?: List;
  name: string;
  description: string;
  tags: string[];
  pathName: string;
  pointer: string;
  valueType: IndexValueType;
  alias: boolean;
  sorting: boolean;
  filtering: boolean;
  searching: boolean;
  guard: boolean;
  defaultOrderDirection: IndexDefaultOrderDirection;
  activated: boolean;
  locked?: boolean;
  buildStatus: IndexBuildStatus;
};

export type IndexMinimal = {
  id: string;
  name: string;
  pathName: string;
  listId: string;
};

export type IndexStats = {
  events: Stats<{
    types: {
      [eventType: string]: number;
    };
  }>;
};

export const indexOrderFields = [
  'createdAt',
  'updatedAt',
  'name',
  'pathName',
  'valueType',
  'alias',
  'sorting',
  'filtering',
  'searching',
  'guard',
  'defaultOrderDirection',
  'activated',
] as const;

export type IndexOrderField = (typeof indexOrderFields)[number];
